module.exports = __webpack_public_path__ + "static/media/background-mobile.7ec1c039.svg";